import {RouteRecordRaw} from "vue-router";
import HeaderView from "@/views/share/HeaderView.vue";

export default <Array<RouteRecordRaw>>[
    {
        path: '/merchant',
        name: 'merchant',
        meta: {auth: true},
        components: {
            default: () => import(/* webpackChunkName: "merchant" */ './MerchantView.vue'),
            header: HeaderView
        },
    }
]
